// utils/getSecretariatColor.ts
// to map the colors of each secretariat
const SECRETARIAT_COLORS: Record<string, string> = {

  academic: 'var(--color-semantic-red)',
  "women's affairs": 'var(--color-semantic-purple)',
  "women's": 'var(--color-semantic-purple)',
  sport: 'var(--color-semantic-green)',
  social: 'var(--color-semantic-yellow)',


  'الأكاديمية': 'var(--color-semantic-red)',
  'شؤون المرأة': 'var(--color-semantic-purple)',
  'الرياضية': 'var(--color-semantic-green)',
  'الإجتماعية': 'var(--color-semantic-yellow)',
}


export function getSecretariatColor(input: string): string {
  const normalized = input.trim().toLowerCase()

  if (SECRETARIAT_COLORS[normalized]) return SECRETARIAT_COLORS[normalized]

  return "";
}